<template>
    <div class="align-left-content"> 
        <p>確認申請後，請將以下資料送至行政大樓總務處：</p>       
        <ol class="dialog-second-content">
            <li>完成基礎培力</li>
            <li>填寫大學生基本素養前測</li>
            <li>完成 20 小時進階培力課程之證明</li>
        </ol>
        <button type="button" class="button button-large" @click="confirm">確定申請</button>
    </div>
</template>
<script>
export default {
    name:"modalTest",
    props:{
        params:{
        }
    },
    data(){
        return{
            info:this.params.firstInput
        }
    },
    created(){
    },
    methods:{
        confirm(){
            this.$emit("close",this.info);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/soft-power/PopModalTest.vue